import { useMomentQueryFilterFunction } from "../hooks/use-client-filtered-moments";

import type { MomentCardMoment } from "../../moment-card/types";
import type { ReactElement } from "react";

export const FilterMoments = <T extends Omit<MomentCardMoment, "additional_recipients_json">>({
  moments,
  children,
}: {
  moments: T[];
  children: (filteredMoments: T[]) => ReactElement;
}): ReactElement => {
  const filteredMoments = useMomentQueryFilterFunction<T>()(moments);
  return children(filteredMoments);
};
